import * as actions from './actions';
import reducer, { initialState } from './reducer';

export default { reducer, initialState, actions };
